import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService } from '../shared/services/toast.service';

export abstract class BaseService {
  protected readonly _httpClient = inject(HttpClient);
  protected readonly _toastService = inject(ToastService);

  protected abstract readonly _route: string;
}
